export const QUERY_KEYS = {
  GET_COMMENTS: 'GET_COMMENTS',
};
